export default __webpack_public_path__ + "static/media/profilePic-2.c8854fc3.jpg";